import { render } from "./BorderOutlineButton.vue?vue&type=template&id=674e8ebc&scoped=true"
import script from "./BorderOutlineButton.vue?vue&type=script&lang=js"
export * from "./BorderOutlineButton.vue?vue&type=script&lang=js"

import "./BorderOutlineButton.vue?vue&type=style&index=0&id=674e8ebc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674e8ebc"]])

export default __exports__